import { Report, ReportType } from 'core/slices/models';

/**
 * Determines the report type based on the active report object.
 * @param activeReport The currently active report (may be undefined)
 * @returns ReportType.TABLE if tableView.routingKey exists, otherwise ReportType.PBI
 */
export function getReportType(activeReport?: Report): ReportType {
  if (activeReport?.tableView?.routingKey) {
    return ReportType.TABLE;
  }
  return ReportType.PBI;
}
